import request from '@/utils/axios';
import { serviceApi } from '@/config';

// 查询投资百科列表
export function queryEncyclopediaList(data) {
  return request({
    url: serviceApi + '/api/services/app/Knowledge/ViewList',
    method: 'post',
    data
  })
}

// 查询常见问答列表
export function queryFaqList(data) {
  return request({
    url: serviceApi + '/api/services/app/Faq/ViewFaqByPaged',
    method: 'post',
    data
  })
}